<script>
  import Author from "./sub-components/Author.svelte";

  const authors = [
    {
      name: "dr hab. Sylwia Jaskulska",
      description: "Prof. UAM, pedagożka, pracuje na stanowisku profesora w Pracowni Pedagogiki Szkolnej na Wydziale Studiów Edukacyjnych Uniwersytetu im. Adama Mickiewicza w Poznaniu. Autorka, współautorka i współredaktorka kilku książek o szkole. Przewodnicząca Rady ds. Kształcenia Szkoły Nauk Społecznych UAM w Poznaniu, członkini Uniwersyteckiego Ośrodka Koordynacyjno-Programowego Kształcenia Nauczycieli UAM w Poznaniu. Zastępczyni redaktor naczelnej \"Rocznika Pedagogicznego\". Pasjonatka dramy edukacyjnej. Zaproponowane w publikacji zasady oceny zachowania są jej zasługą.",
      image: "/images/sylwia_jaskulska.jpg"
    },
    {
      name: "Łukasz Korzeniowski",
      description: "Założyciel i prezes Stowarzyszenia Umarłych Statutów, działacz na rzecz praw ucznia, społecznik. Student III roku prawa na Wydziale Prawa i Administracji UJ. Od ponad trzech lat mocno zainteresowany prawem oświatowym, systemem edukacji i praworządnością w szkołach. Autor licznych artykułów popularnonaukowych z zakresu prawa oświatowego i praw ucznia, popularyzator wiedzy z tego obszaru. Redaktor publikacji, odpowiedzialny za jej ostateczny kształt. Czuwał nad tym, by wzór statutu jako całość, jak i poszczególne zawarte w nim rozwiązania były zgodne z prawem.",
      image: "/images/lukasz_korzeniowski.jpg"
    },
    {
      name: "dr Gabriela Olszowska",
      description: "Polonista, edukator, autorka wielu artykułów metodycznych i podręczników do języka polskiego oraz programów nauczania. Doktorat na UJ z podręcznikoznawstwa w odniesieniu do tzw. kanonu literackiego. Wieloletni dyrektor szkoły, prowadząca liczne zajęcia na studiach z zarządzania oświatą, w tym z praktyki szkolnego oceniania. Rzeczoznawca MEN ds. podręczników szkolnych. Prezes fundacji \"Czerwona kreska\". Jej doświadczenie pomogło w konstruowaniu zawartych we wzorze statutu przepisów techniczno-administracyjnych i tych dotyczących oceniania.",
      image: "/images/gabriela_olszowska.jpg"
    },
    {
      name: "Anna Szulc",
      description: "Nauczycielka matematyki i wychowawczyni w I LO im. K. Wielkiego w Zduńskiej Woli z ponad trzydziestoletnim stażem. Mediatorka społeczna, tutorka, laureatka Konkursu im. J. Kubiak \"Nauczyciel Mediator\" (2016). Autorka książki \"Nowa Szkoła – zmianę edukacji warto zacząć przy tablicy\". Od kilku lat dzieli się swoją wiedzą i doświadczeniem z nauczycielami, organizując wizyty studyjne oraz występując jako prelegentka na licznych konferencjach i webinarach. System oceniania zawarty w publikacji został oparty na jej własnej koncepcji, którą już od dawna stosuje w praktyce.",
      image: "/images/anna_szulc.jpg"
    }
  ];
</script>

<div id="anchor-authors" class="container-fluid block mb-4">
    <div class="row box w-100">
        <h1 class="title pt-3 text-left col-10 col-lg-8 offset-1 offset-lg-2">
            O autorach
        </h1>
        <div class="col-12 col-md-8 offset-md-2">
            {#each authors as author, index}
                <Author
                        image={author.image}
                        name={author.name}
                        description={author.description}
                        reversed={index % 2 === 1}
                />
            {/each}
        </div>
    </div>
</div>

<style>
    .box {
        margin: 0 !important;
    }

    .block {
        min-height: 100vh;
        padding: 0 !important;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
    }
</style>
